import styled, { css } from 'styled-components';
import { fontWeight } from '../../../../theme/typography/fontWeight.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { unit, padding, pxToRem, marginBottom, marginRight } from '../../../foundation/spacing/utils.js';
import { fontSize } from '../../../../theme/typography/fontSize.js';
import { interactiveTransition } from '../../../foundation/theme/utils.js';

var FOCUS_LINE_SIZE = 1;
var NAV_BORDER_BOTTOM = 0.25;
var activeTabStyles = css(["", ";color:", ";border-bottom:", " solid ", ";&:disabled{color:", ";border-color:", ";}"], fontWeight('medium'), themeGet('colors.text.300'), unit(1), themeGet('colors.brandPrimary.1000'), themeGet('colors.disabled.200'), themeGet('colors.disabled.200'));
var hoverTabStyles = css(["border-bottom:", " solid ", ";"], unit(1), themeGet('colors.brandPrimary.1000'));
var TabNavContainer = styled.div.withConfig({
  displayName: "TabNavContainer",
  componentId: "sc-ss6ljl-0"
})(["background-color:", ";border-bottom:", " solid ", ";display:flex;"], themeGet('colors.background.50'), unit(NAV_BORDER_BOTTOM), themeGet('colors.border.100'));
var ScrollableTabNav = styled.div.withConfig({
  displayName: "ScrollableTabNav",
  componentId: "sc-ss6ljl-1"
})(["display:flex;flex:1 1 auto;scrollbar-width:none;overflow-x:auto;overflow-y:hidden;"]);
var ContentContainer = styled.div.withConfig({
  displayName: "ContentContainer",
  componentId: "sc-ss6ljl-2"
})(["&:focus-visible{outline:none;box-shadow:0 0 0 ", " ", ";}"], unit(1), themeGet('colors.focus.primary'));
var TabContainer = styled.button.withConfig({
  displayName: "TabContainer",
  componentId: "sc-ss6ljl-3"
})(["position:relative;height:", ";", ";", ";", ";cursor:pointer;appearance:none;background-color:transparent;border:0;color:", ";border-bottom:", " solid transparent;", ";", ";white-space:nowrap;flex:0 1 auto;", " &:not(:last-child){", ";}&:hover:not(:disabled){", ";}&:focus-visible{outline:0;}", ";&:disabled{color:", ";cursor:auto;}"], unit(10), padding(0, 2), fontWeight('normal'), fontSize('base', pxToRem(22)), themeGet('colors.text.100'), unit(1), marginBottom(-NAV_BORDER_BOTTOM), interactiveTransition, function (_ref) {
  var $stretch = _ref.$stretch;
  return $stretch && css(["flex:1 1 auto;"]);
}, marginRight(4), hoverTabStyles, function (props) {
  return props.$isActive && activeTabStyles;
}, themeGet('colors.disabled.200'));
// Prevent tab width "jumping" when changing font-weight on hover
var ControlWidth = styled.span.withConfig({
  displayName: "ControlWidth",
  componentId: "sc-ss6ljl-4"
})(["", ";visibility:hidden;"], fontWeight('medium'));
var Text = styled.span.withConfig({
  displayName: "Text",
  componentId: "sc-ss6ljl-5"
})(["display:block;position:absolute;width:calc(100% - ", ");top:50%;left:50%;transform:translate(-50%,-50%);text-align:center;border:", " solid transparent;border-radius:", ";", ";", ":focus-visible &{border:", " solid ", ";}"], unit(FOCUS_LINE_SIZE * 2), unit(FOCUS_LINE_SIZE), themeGet('borderRadius.sm'), interactiveTransition, TabContainer, unit(FOCUS_LINE_SIZE), themeGet('colors.focus.primary'));

export { ContentContainer, ControlWidth, ScrollableTabNav, TabContainer, TabNavContainer, Text };
